import { Fragment, useState, useCallback } from 'react';
import { useCookies } from "react-cookie";
import { Text } from '../../FormControls/Text';
import { Stack } from '../../FormControls/Stack';
import { Box } from '../../FormControls/Box';
import { Input } from '../../FormControls/Input';
import { Button } from '../../FormControls/Button';
import { AlertBox } from "../../FormControls/alert";
import { useDispatch, useSelector } from 'react-redux'
import { 
    //ENDPOINTS
    createOtp, 
    valOtp, 
    loginStore,
    //SET DATA
    setPos,
    setTokenStore,
    setGroup,
    setStoreName,
    setCountrySrore,
    setCurrencyStore,
    setIdStore
} from '../../../../main/slices/storeSlice';
import { ScreenControl } from '../ScreenControl';
import { useEffect } from 'react';
import { ContentPaste, Sync } from '@mui/icons-material';
import { COLORS } from '../../../styles/defaults';

const CodeComponent = ({ email, storeId, wldId, handleDigitsChange, handleKeyDown, digit, setDigit, setTimerActive, setCookiesTime }) => {
    // EQUIVALENT TO 3 MINUTES
    const EXPIRATION_TIME = 180000;
    const [cookies] = useCookies(["otpTime"]);
    const [count, setCount] = useState({ sec: "--", min: "-" });

    // REMAINING TIME IN MILISECONDS
    const [time, setTime] = useState(Number(cookies["otpTime"]) || EXPIRATION_TIME);
    const dispatch = useDispatch();

    // PASTE CODE
    const handlePaste = async () => {
        try {
            // READ CLIPBOARD
            const copyCode = await navigator.clipboard.readText();
            const otpArray = copyCode.split('').slice(0, 6);
            setDigit(otpArray)
            // ADD TEXT INTO OTP'S INPUTS
            for (let i = 0; i < otpArray.length; i++) {
                const nextField = document.getElementById(`otp${i}`);
                nextField.value = otpArray[i];
            } 
        } catch (err) {
          console.error('invalid action');
        }
      };

    const calculateTime = useCallback(() => {
        // CALCULATE THE REMAINING TIME (IN MINUTES)
        const remaining = (EXPIRATION_TIME - ((new Date()).getTime() - time)) / 60000;

        // IF THERE IS STILL TIME
        if (remaining > 0) {
            if(remaining<0.02){//DISABLE BUTTON ACEPT
                setTimerActive(false);
            }
            // SET THE MINUTES AND SECONDS
            const [min, sec] = String(remaining).split('.');
            setCount({
                sec: Math.round(Number("0." + sec) * 60),
                min: min
            });
        }
    }, [time]);

    // START TIMER
    useEffect(() => {
        const timer = setInterval(() => calculateTime(), 1000);
        return () => clearInterval(timer);
    }, [calculateTime]);

    // RESET TIME
    const restartTimer = () => {
        setTimerActive(true)
        // Reiniciar el tiempo a EXPIRATION_TIME
        const now = new Date().getTime();
        setTime(now);
        setCookiesTime("otpTime", now, { path: "/" }); 
        setCount({ sec: 0, min: 3 });
    };

    // ACTIONS WHEN PRESS NUMBER
    const handleChange = useCallback((i) => (e) => {
        const value = e.target.value;
        if (/^\d$/.test(value) || value === '') {
            handleDigitsChange(i, value);
        }
    }, [handleDigitsChange]);

    const handleUp = useCallback((i) => (e) => {
        handleDigitsChange(i, e.target.value);
    }, [handleDigitsChange]);

    const handleDown = useCallback((i) => (e) => {
        handleKeyDown(i, e);
    }, [handleKeyDown]);

    useEffect(() => {
        restartTimer();
    }, []);

    return (
        <>
            <Fragment>
                <Box>
                    <Text classes={["title", "center"]}>Código de verificación enviado</Text>
                    <div style={{ marginBottom: "2rem" }}></div>
                    <Text classes={["text", "center"]}> Solicita al propietario del comercio que comparta el código para tener acceso a este comercio </Text>
                    <div style={{ marginBottom: "4rem" }}></div>
                    <Text classes={["subtitle"]}> Ingresa el código </Text>
                    <Stack 
                        style={{ paddingLeft: "0.80rem"}}
                        flex={{ justifyContent: "space-between" }}>
                        {[0, 1, 2, 3, 4, 5].map((i) =>
                            <Input
                                key={i} 
                                type="text"
                                style={{ width: "2.35rem" }}
                                value={digit[i]}
                                classes={["width15", "textCenter"]}
                                maxLength={1}
                                attributes={{ 
                                    inputMode: "numeric",
                                    // pattern: "[0-9]{1}",
                                    maxLength: 1, 
                                    id: `otp${i}`,
                                    onKeyUp: handleUp(i),
                                    onKeyDown: handleDown(i),
                                }}
                                placeHolder="-" 
                                onChange={handleChange(i)}
                            />
                        )}
                    </Stack>
                
                    { ((count.min == 0 && count.sec <= 1) || (count.min=="-" && count.sec=="--")) ? (
                        <Box style={{ marginTop: "1em" }}>
                            <Stack flex={{ flexDirection: "row", justifyContent: "center", alignItems: "center" }}>
                                <Button
                                    style={{"color": COLORS.primary.acept, "background": COLORS.primary.acept}}
                                    onClick={() => {
                                        dispatch(createOtp({
                                            "origin":"worldpos",
                                            "wldId": wldId,
                                            "storeId": storeId,
                                            "email": email,
                                            "type": "connect"
                                        }))

                                        restartTimer();
                                    }}
                                >
                                    <Stack flex={{ flexDirection: "row", gap: 5 }}>
                                        <Sync style={{"color": COLORS.primary.font}} fontSize="inherit" />
                                        <Text 
                                            style={{"color": COLORS.primary.font}}
                                            classes={["description", "center"]} >
                                            Re enviar código
                                        </Text>
                                    </Stack>
                                </Button>
                            </Stack>
                        </Box>    
                        ) : (
                        <Box style={{ marginTop: "1em" }}>
                            <Stack flex={{ flexDirection: "row", justifyContent: "center", alignItems: "center" }}>
                                {/* <Text>hola</Text> */}
                                <Button
                                    style={{"color": COLORS.primary.font, "background": COLORS.primary.font}}
                                    onClick={() => {handlePaste()}}
                                >
                                    <Stack flex={{ flexDirection: "row", gap: 5 }}>
                                        <ContentPaste style={{"color": COLORS.primary.main}} fontSize="inherit" />
                                        <Text 
                                            style={{"color": COLORS.primary.main}}
                                            classes={["description", "center"]} 
                                        >
                                            Pegar código
                                        </Text>
                                    </Stack>
                                </Button>
                            </Stack>
                            <Text 
                                classes={["description", "center"]} 
                                style={{ 
                                    "align":"center", 
                                    "justifyContent": "flex-start", 
                                    "margin": "0.5em 0",
                                    // "color": COLORS.primary.main, "background": COLORS.primary.fondoItem
                                }}>
                                Reenviar código en:
                            </Text>
                            <Stack flex={{ alignItems: "baseline", justifyContent: "center" }}>
                                <Text classes={["bigTitle", "autoWidth"]}> {count.min} </Text>
                                <Text classes={["description", "autoWidth"]}> min </Text>
                                <div style={{ margin: "0 0.5em" }}></div>
                                <Text classes={["bigTitle", "autoWidth"]}> {count.sec} </Text>
                                <Text classes={["description", "autoWidth"]}> seg </Text>
                            </Stack>
                        </Box>)
                    }
                </Box>
                <div style={{ marginBottom: "2rem" }}></div>
            </Fragment>
            
        </>
        
    );
}

const Main = ({ dimensions, path, state, store }) => {
    // COMPONENT STATES
    let [digits, setDigits] = useState(Array(6).fill(""));
    const [timerActive, setTimerActive] = useState(true);
    const [cookies, setCookies] = useCookies(["otpTime"]);
    const dispatch = useDispatch();
    // ALERT
    const [showAlert, setShowAlert] = useState(false); // view alert
    const [alertMessage, setAlertMessage] = useState('');
    const [alertType, setAlertType] = useState('success');
    const [alertTitle, setAlertTitle] = useState(null);

    // CLOSE ALERT MESSAGE
    const handleCloseAlert = () => setShowAlert(false);

    // WRITE OTP 
    const handleDigitsChange = (i, val) => {
        if (/[^0-9]/.test(val)) return;
        let newOtp = [...digits];
        newOtp[i] = val;
        setDigits(newOtp);

        // GO TO THE NEXT INPUT
        if (val !== "" && i < 5) {
            const nextField = document.getElementById(`otp${i + 1}`);
            nextField?.focus();
        }
    }

    // CLEAR OTP
    const handleKeyDown = (i, e) => {
        // IF PRESS "BACKSPACE", GO BACK INPUT
        if (e.key === "Backspace" && digits[i] === "") {
            if (i > 0) {
                const prevField = document.getElementById(`otp${i - 1}`);
                prevField?.focus();
            }
        }
    };

    // GENERATES THE CONTRACT AND ONESHOT REQUETS
    const verifyOtp = async () => {
        if (digits.length > 0){
            return await dispatch(valOtp({
                email: store.token.value,
                origin: "worldpos",
                numberOtp: digits.reduce((a, b) => a + b)
            })).unwrap()
            .then(async ({ response }) => {
                if (response.code === 200) {
                    return await dispatch(loginStore({
                        "origin": "worldpos",
                        "wldId": state.idWLD,
                        "pos": `R${store.pos.value}`,
                    }))
                    .unwrap()
                    .then(({ response }) => {
                        if (response.code==200) {
                            let group= response.data.group;
                            let pos= response.data.pos;
                            let id= response.data.id;
                            let name= response.data.name;
                            let currency= response.data.currency;
                            let country= response.data.country;
                
                            //SETO LOS DATOS DE LA TIENDA
                            dispatch(setPos({ value: pos, error: false }));
                            dispatch(setTokenStore({ value: "", error: true }));
                            dispatch(setIdStore({ value: id, error: false }));
                            dispatch(setGroup({value: group, error: false }));
                            dispatch(setStoreName({ value: name, error: false }));
                            dispatch(setCountrySrore({value: country, error: false }));
                            dispatch(setCurrencyStore({ value: currency, error: false }));

                            path = "email";
                            return true
                        }else{
                            return false
                        }
                    }).catch(e => {
                        return false
                    });
                }else{
                    return false
                }
            })
            .catch(e => {
                return false
            });
        }
    }

    function isFull(array) {
        return array.every(item => item.trim() !== ""); // Verifica que ningún elemento sea una cadena vacía
    }

    const route = (path, timerActive) => {
        const regex = /^[0-9]+$/
        return {
            index: { bw: 1, fw: 8 },  // IF bw = -1, STAYS IN THE CURRENT SCREEN TRIGGER BY THE BACKWARD BUTTON
            path: "otp",
            disabled: !isFull(digits) || !timerActive,
            beforeSubmit: async () => {
                const returnVal = await verifyOtp()
                if(returnVal==false){
                    setAlertTitle("Error")
                    setAlertType('error');
                    setAlertMessage(`Código invalido.`);
                    setShowAlert(true);
                    for (let i = 0; i < 6; i++) {
                        const nextField = document.getElementById(`otp${i}`);
                        digits[i]="";
                        nextField.value = "";
                    } 
                }else{
                    return true;
                }
            }
        }
    }

    return (
        <Fragment>
            <div style={{ padding: "0 1.5rem" }}>
                {/* ALERT */}
                {showAlert && (
                    <AlertBox
                    message={`${alertMessage}`}
                    type={alertType}
                    title={alertTitle}
                    onClose={handleCloseAlert}
                    />
                )}
                <CodeComponent
                    cookies={cookies}
                    email={store.token.value}
                    storeId={store.idStore.value}
                    wldId={state.idWLD}
                    handleDigitsChange={handleDigitsChange}
                    handleKeyDown={handleKeyDown}
                    digit={digits}
                    setDigit={setDigits}
                    setCookiesTime= {setCookies}
                    setTimerActive = {setTimerActive}
                    number={'123'}
                />
            </div>
            {/* CONTROLLER */}
            <ScreenControl
                btncolor={"cobrarBtn"}
                {...route(path, timerActive)}
            />
            <div style={{ marginBottom: "15rem" }}></div>
        </Fragment>
    );
}

export const ValUser  = ({ dimensions, path }) => {
    const state = useSelector(({ user }) => user);
    const store = useSelector(({ store }) => store);
    return <Main dimensions={dimensions} path={path} state={state} store={store} />;
}
